/**
 * The one calibration question only the browser can answer: is this the same
 * screen the patient measured?
 *
 * The calibration MATHS lives on the server (`therapy/calibration.ts`) so there
 * is one implementation of what a degree means. This is not that. It compares
 * the screen the patient is sitting at right now, which the server has never
 * seen, against the dimensions stored when they last calibrated.
 *
 * NOT A DEVICE PROFILE (explicitly rejected). Nothing is fingerprinted and no
 * baseline is kept per device. Two numbers are compared for one purpose: §4's
 * "re-offer if screen dimensions change".
 */

export interface ScreenSize {
  screenWidthPx: number;
  screenHeightPx: number;
}

/**
 * Drives an OFFER to recalibrate, never a block. A patient travelling with a
 * laptop should be nudged, not stopped at the door — a session run at slightly
 * the wrong size is worth more than a session not run at all.
 */
export function screenChanged(calibrated: ScreenSize, current: ScreenSize): boolean {
  return (
    calibrated.screenWidthPx !== current.screenWidthPx ||
    calibrated.screenHeightPx !== current.screenHeightPx
  );
}
